module.exports = __webpack_public_path__ + "assets/img/next.08200a40.svg";